import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=6a09facc&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=6a09facc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a09facc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a09facc')) {
      api.createRecord('6a09facc', component.options)
    } else {
      api.reload('6a09facc', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=6a09facc&scoped=true", function () {
      api.rerender('6a09facc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chart/BarChart.vue"
export default component.exports